// extracted by mini-css-extract-plugin
module.exports = {"container":"GlobalInvoiceCard_container__-7Mti"};